import * as React from 'react'
import * as styles from './content.page.styl'
import cx from 'classnames'
import Spinner from '@src/components/common/loader'

export interface Props {
  id?: string
  role?: string
  className?: string
  noMargin?: boolean
  noPadding?: boolean
  withPadding?: boolean
  loading?: boolean
  onLoaded?: () => void
}

const ContentPage: React.FC<Props> = ({
  id,
  role,
  className,
  children,
  loading,
  noMargin,
  noPadding,
  withPadding = true,
  onLoaded
}: React.PropsWithChildren<Props>) => {
  function handlLoaded() {
    if (typeof onLoaded === 'function') {
      onLoaded()
    }
  }
  React.useEffect(() => {
    if (!loading) {
      handlLoaded()
    }
  }, [loading])

  return !loading ? (
    <div
      role={role}
      id={id}
      className={cx(className, styles.contentPage, {
        [styles.withPadding]: withPadding,
        [styles.noMargin]: noMargin,
        [styles.noPadding]: noPadding
      })}
    >
      {children}
    </div>
  ) : (
    <Spinner loading={loading} />
  )
}
export default ContentPage
